/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import React from "react";
import dynamic from 'next/dynamic'
import {TFacet} from "@/app/types/TFacet";
const FacetInStockToggle = dynamic(() => import("@/app/components/algolia/facets/UI/FacetInStockToggle"), {ssr: false});
const FacetMenu = dynamic(() => import("@/app/components/algolia/facets/UI/FacetMenu"), {ssr: false});
const FacetRange = dynamic(() => import("@/app/components/algolia/facets/UI/FacetRange"), {ssr: false});
const FacetRangeSlider = dynamic(() => import("@/app/components/algolia/facets/UI/FacetRangeSlider"), {ssr: false});
const FacetRefinementList = dynamic(() => import("@/app/components/algolia/facets/UI/FacetRefinementList"), {ssr: false});
const FacetInStock = dynamic(() => import("@/app/components/algolia/facets/UI/FacetInStock"), {ssr: false});

const FacetGeneral = (props:{
    config:TFacet,
}) => {
    const attribute = props.config.attribute;

    // Exceptions:
    if(attribute === "in_stock") {
        return <FacetInStock config={props.config} />
    }

    // Exceptions:
    if(attribute === "availability") {
        return <FacetInStockToggle config={props.config} />
    }

    switch (props.config.type) {
        case 'conjunctive':
            return <FacetRefinementList config={props.config} />;

        case 'disjunctive':
            return <FacetMenu config={props.config} />

        case 'priceRanges':
            return <FacetRange config={props.config} />

        case 'slider':
            return <FacetRangeSlider config={props.config} />

        default:
            return <FacetMenu config={props.config} />
    }
}

export default FacetGeneral;
